import React from 'react';
import { useLanguage } from '../i18n/LanguageContext';

const LanguageSwitcher = ({ className = '' }) => {
  const { lang, setLang, languages } = useLanguage();

  return (
    <div
      className={`inline-flex items-center rounded-full border border-white/10 bg-white/5 p-1 ${className}`}
      role="group"
      aria-label="Language"
    >
      {languages.map((code) => (
        <button
          key={code}
          type="button"
          onClick={() => setLang(code)}
          aria-pressed={lang === code}
          className={`px-3 py-1 rounded-full text-xs font-semibold uppercase tracking-widest transition-colors ${
            lang === code
              ? 'bg-white text-black'
              : 'text-gray-400 hover:text-white'
          }`}
        >
          {code}
        </button>
      ))}
    </div>
  );
};

export default LanguageSwitcher;
